<template>
  <div class="login-page" v-if="!isLoading">
     <div class="err-toast" v-if="errToast">
        <span>{{ errToast }}</span>
      </div>

    <img
      class="login-logo"
      src="/v2/config/get_file?config_type=0&config_id=0&name=custom_main_logo"
    />
    <p class="login-error" v-text="error_msg"></p>
    <div class="login-name" v-show="domainOpen">
      <select
        class="domins-select icon-currentPath-down"
        ref="clickSelect"
        v-show="domainOpen"
        v-model="selectedOption"
        @change="showActive"
        @click="iconCurrentPathChange"
        id="select"
      >
        <option
          v-for="domainOne in domainArrList"
          :value="domainOne.timesid"
          :key="domainOne.timesid"
        >
          {{ domainOne.dnName }}
        </option>
      </select>
      <span
        class="icon-currentPath-down"
        v-bind:class="{
          'icon-currentPath-down': isChange,
          'icon-currentPath-up': !isChange,
        }"
      ></span>
    </div>
    <div class="login-msg" @keyup.enter="login">
      <div class="login-input" style="border-bottom: 1px solid #dadddf">
        <input
          type="text"
          maxlength="32"
          placeholder="请输入用户名"
          v-model="username"
          @focus="focus"
          @blur="blur"
        />
      </div>
      <div class="login-input login-password">
        <input
          type="password"
          maxlength="64"
          placeholder="请输入密码"
          v-model="pwd"
          @focus="focus"
          @blur="blur"
        />
        <!-- <input type="text" maxlength="64" placeholder="请输入密码" v-else v-model="pwd" @focus="focus" @blur="blur"/> -->
      </div>
    </div>
    <!--      <div class="login-domain">
        <input type="checkbox" v-model="domain"><span style="vertical-align: middle;"> 域用户登录</span>
      </div>-->
    <button
      @click.stop="login"
      ref="clickBtn"
      v-if="disabled"
      style="background: #0A64FA ; margin-top: 0.8rem"
    >
      登录
    </button>
    <button
      @click.stop="login"
      v-else
      disabled
      style="background: #8fcdff; margin-top: 0.8rem"
    >
      登录
    </button>
    <div class="bottom">
      <span
        class="bottomText"
        v-if="isVisiable"
        v-bind:style="{ position: positionText, bottom: bottomText}"
        >©Filez</span
      >
    </div>
    <!-- 三方登录 -->
    <div class="third-box" v-if="isLink">
      <div
        class="third-login-list"
        v-for="item in thirdLoginList"
        :key="item.id"
        @click="handleLink(item)"
      >
        <img :src="item.icon" alt="" />{{ item.name }}
      </div>
    </div>
  </div>
  <div v-else>Loading....</div>
</template>

<script>
import * as UserManager from '../../SDK/UserManager'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      username: '',
      selectedOption: '0',
      pwd: '',
      error_msg: '',
      domainsId: '',
      domain: false,
      isLoading: true,
      isVisiable: true,
      disabled: false,
      // isShowPwd: true,
      domainArrs: [{ dnName: '普通登录', timesid: '0' }],
      domainArrList: [],
      thirdLoginList: [],
      domainOpen: false,
      isChange: true,
      positionText: 'fixed',
      bottomText: '0.5rem',
      errToast: ''
    }
  },
  beforeCreate () {
  },
  created () {
    //  二次认证页面toast
    if (Cookies.get('err_message')) {
      this.errToast = Cookies.get('err_message')
      setTimeout(() => {
        this.errToast = ''
      }, 3000)
    }
    this.getAuthlogin()
    this.isLoading = false
    UserManager.getDomains()
      .then(response => {
        if (response.length > 0) {
          this.domainOpen = true
          this.domain = true
          this.selectedOption = response[0].timesid ? response[0].timesid : '0'
          this.domainArrList = this.domainArrs.concat(response)
          this.domainsId = this.selectedOption
        } else {
          this.domainOpen = false
          this.domain = false
        }
      })
  },
  methods: {
    login () {
      this.$refs.clickBtn.style.background = '#065BD1'
      if (this.username === '') {
        this.error_msg = '用户名不能为空'
        this.$refs.clickBtn.style.background = '#0A64FA '
        return
      }
      if (this.pwd === '') {
        this.error_msg = '密码不能为空'
        this.$refs.clickBtn.style.background = '#0A64FA '
        return
      }
      let params = {
        user_slug: this.username,
        password: this.pwd,
        bind_type: this.selectedOption !== '0'
      }
      if (this.domainsId) {
        params.timesid = this.domainsId
      }
      Cookies.remove('X-LENOVO-SESS-ID')
      UserManager.signin(params)
        .then(response => {
          if (response.captcha) {
            let postData = {
              user_slug: this.username,
              lenovo_token: response.lenovo_token
            }
            UserManager.getCode(postData)
              .then(response => {
                let info = JSON.stringify(response)
                sessionStorage.setItem('info', info)
                sessionStorage.setItem('refresh', true)
                sessionStorage.setItem('user_slug', this.username)
                this.$router.push({ path: '/secondary-certification' })
              }, error => {
                let info = JSON.stringify(error)
                sessionStorage.setItem('info', info)
                sessionStorage.setItem('refresh', true)
                sessionStorage.setItem('errorMsg', true)
                sessionStorage.setItem('user_slug', this.username)
                this.$router.push({ path: '/secondary-certification' })
              })
            return
          }
          sessionStorage.userInfo = JSON.stringify(response)
          this.$store.commit('login', response)
          this.$router.replace({ path: '/' })
          location.reload()
        }, error => {
          this.error_msg = error.message
          this.pwd = ''
          // this.isShowPwd = false
          this.$refs.clickBtn.style.background = '#0A64FA '
        })
    },
    focus () {
      this.disabled = true
      // if (!this.isShowPwd) {
      //   this.pwd = ''
      //   this.isShowPwd = true
      // }
      this.positionText = 'static'
      this.isVisiable = false
    },
    blur () {
      this.positionText = 'fixed'
      this.isVisiable = true
    },
    showActive () {
      this.domainsId = this.selectedOption
      this.domain = this.selectedOption ? 'true' : 'false'
      console.log(this.domainsId)
      this.isChange = true
    },
    test () {
      console.log(this.$refs.clickSelect)
    },
    iconCurrentPathChange () {
      this.isChange = false
    },
    // 三方登录接口
    getAuthlogin () {
      let params = {
        'name': 'marne_sso_configs',
        'terminal': 'web'
      }
      UserManager.authlogin(params).then(res => {
        this.thirdLoginList = res.marne_sso_configs.map(ele => {
          if (ele.serviceType === 'corp_wx') {
            ele.icon = '../../../static/img/wechat.svg'
          } else if (ele.serviceType === 'dingding') {
            ele.icon = '../../../static/img/dingTalk.svg'
          }
          return ele
        })
      })
    },

    // 三方登录跳转
    handleLink (item) {
      let redirectUrl = window.localStorage.getItem('linkUrl')
      window.location = item.url + '?redirect_url=' + encodeURIComponent(redirectUrl)
    }

  },
  watch: {
    // 'pwd': function (val, oldVal) {
    //   if (val === '') {
    //     this.isShowPwd = true
    //   }
    // }
  },
  computed: {
    // 判断是否显示三方登录
    isLink () {
      if (this.thirdLoginList.length >= 1 && window.localStorage.getItem('linkUrl')) {
        return true
      }
      return false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
@import '../../common/stylus/global.styl';
@import '../../../static/font-icon/style.css';

.login-page {
  font-size: 0.4rem;
  width: 8rem;
  margin: 2rem auto 0;
  position: relative;
  .err-toast {
      position: absolute;
      top: -1rem;
      text-align: center;
      background: #F8ECC0;
      border: 1px solid #EDC468;
      padding : 10px 20px;
      border-radius: 2px;
      span{
        font-size: 0.4rem;
        display: inline-block;
        text-align: left;

      }
    }
  .login-logo {
    width: 4rem;
    height: 2.7rem;
    margin-left: 2rem;
    margin-bottom: 2rem;
  }

  .login-name {
    position: relative;
    background: #f8fafb;
  }

  .login-error {
    color: red;
    margin: 0.3rem 0;
  }

  .domins-select {
    color: gray;
    /* background: #f8fafb; */
    background: rgba(0, 0, 0, 0);
    border: 1px solid #DADDDF;
    border-bottom: none;
    width: 8rem;
    height: 1.2rem;
    font-size: 0.4rem;
    outline: none;
    /* color: #b6b9ba */
    padding-left: 0.3rem;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    padding-right: 14px;
    background-size: 0.7rem 1.2rem;
    position: relative;
    z-index: 2;
  }

  .icon-currentPath-down::after {
    z-index: 0;
    position: absolute;
    color: gray;
    option;
    font-size: 0.1rem;
    right: 17px;
    top: 24px;
  }

  .icon-currentPath-up::after {
    z-index: 0;
    position: absolute;
    color: gray;
    option;
    font-size: 0.1rem;
    right: 17px;
    top: 24px;
  }

  .login-msg {
    border: 1px solid #DADDDF;

    .login-password {
      /* margin-top: 0.3rem */
      /* border-radius: .08rem */
      /* border:1px solid #DADDDF */
      /* width: 8rem */
      /* background: #F8FAFB */
    }

    .login-input {
      height: 1.2rem;
      line-height: 1.2rem;
      padding-left: 0.35rem;
      color: $thin_font;
      /* border-radius: .08rem */
      border: 1px solid #DADDDF;
      width: 7.6rem;
      background: #F8FAFB;

      input {
        line-height: 0.6rem;
        border: none;
        background: transparent;
        width: 95%;
        height: 100%;
      }
    }
  }

  /* .login-domain */
  /* margin-top: .4rem */
  /* input */
  /* height: .4rem */
  /* width: .4rem */
  /* vertical-align: middle */
}

.login-error {
  color: red;
  margin: 0.3rem 0;
}

button {
  /* margin-top: .8rem; */
  width: 8rem;
  font-size: 0.4rem;
  height: 1.2rem;
  line-height: 1.2rem;
  border: 1px solid #fff;
  border-radius: 0.08rem;
  color: #fff;
}

.bottom {
  text-align: center;
  font-family: Helvetica;
  font-size: 0.3rem;
  color: #929CA9;
  line-height: 19px;
  letter-spacing: 0;
}

.bottomText {
  margin: 0.2rem -0.7rem;
}

.third-box {
  .third-login-list {
    font-size: 0.373333rem;
    margin-top: 0.32rem;
    height: 0.533333rem;
    width: calc(50% - 0.533333rem);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    float: left;
    line-height: 0.533333rem;

    &:nth-of-type(2n) {
      float: right;
      text-align: right;
    }

    img {
      margin-right: 0.453333rem;
      height: 0.453333rem;
      object-fit: contain;
      vertical-align: text-bottom;
    }
  }
}
</style>



// WEBPACK FOOTER //
// login.vue?f9e6ab94